import { useCallback } from 'react';
import { useMutation } from '@ts-core/lib/apollo';

import { Message } from '../types';
import {
  markMessageAsReadMutation,
  MarkMessageAsReadMutationResult,
  MarkMessageAsReadMutationVariables,
} from '../graphql/mutations/markMessageAsReadMutation';
import { markNotificationsAsSeenMutation } from '../graphql/mutations/markNotificationsAsSeenMutation';

export interface MessageActionsHookPayload {
  onMarkMessageAsRead: (message: Message) => void;
  onMarkNotificationsAsSeen: () => void;
}

export default function useMessageActions(): MessageActionsHookPayload {
  const [markMessageAsRead] = useMutation<MarkMessageAsReadMutationResult, MarkMessageAsReadMutationVariables>(markMessageAsReadMutation);
  const onMarkMessageAsRead = useCallback(
    (message: Message) => {
      markMessageAsRead({ variables: { messageId: message.id } });
    },
    [markMessageAsRead]
  );

  const [markNotificationsAsSeen] = useMutation(markNotificationsAsSeenMutation);
  const onMarkNotificationsAsSeen = useCallback(() => {
    markNotificationsAsSeen();
  }, [markNotificationsAsSeen]);

  return {
    onMarkMessageAsRead,
    onMarkNotificationsAsSeen,
  };
}
